// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__HBbgM","form":"styles_form__3G3ab"};